const PATH = "/api/v1/pms";

const ENDPOINTS = {
  PMS_INFO_PROPERTY: "/info/property/",
};

export type PMSEndpoints = keyof typeof ENDPOINTS;
export const PMSCollection = { PATH, ENDPOINTS };
